import { ReactNode } from 'react';
import { IconProps } from './types';

interface SvgComponentProps extends IconProps {
  children: ReactNode;
}

export const SvgComponent = ({
  width,
  height,
  className,
  children,
  onClick,
  ...props
}: SvgComponentProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    onClick={onClick}
    className={(onClick ? 'cursor-pointer ' : '') + (className ?? '')}
    {...props}
  >
    {children}
  </svg>
);
